import clsx from "clsx";
import React from "react";
import * as styles from "./radio-button-with-label.css";

export interface RadioButtonWithLabelProps {
    id: string;
    name: string;
    value: string;
    checked?: boolean;
    onChange: () => void;
    children?: React.ReactNode;
}

export function RadioButtonWithLabel({
    id,
    name,
    value,
    checked = false,
    onChange,
    children,
}: RadioButtonWithLabelProps): React.ReactElement {
    return (
        <div className={styles.container}>
            <input
                className={clsx(styles.input, {
                    [styles.inputChecked]: checked,
                })}
                type="radio"
                id={id}
                name={name}
                value={value}
                checked={checked}
                onChange={onChange}
            />
            <label htmlFor={id} className={styles.label}>
                {children}
            </label>
        </div>
    );
}
